import { render, staticRenderFns } from "./ReportC.vue?vue&type=template&id=9c36b81c&scoped=true&"
import script from "./ReportC.vue?vue&type=script&lang=js&"
export * from "./ReportC.vue?vue&type=script&lang=js&"
import style0 from "./ReportC.vue?vue&type=style&index=0&id=9c36b81c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c36b81c",
  null
  
)

export default component.exports